import type { MiddlewareAPI } from 'redux';
import { dealRefreshDeferMiddleware } from '@makemydeal/dr-sales-checkin-store';
import { reducer } from '@makemydeal/dr-sales-checkin-store';
import { APP_NAME, SALESCHECKIN_ROOT_ROUTE } from './constants';
import { salesCheckinMiddleware } from './middleware';

// Compose the shared dealRefreshDeferMiddleware into the sales-checkin activity middleware so the
// DealRefreshModal is deferred during Trade-In before the shared dealRefreshModalMiddleware reacts to the event.
const salesCheckinActivityMiddleware = (store: MiddlewareAPI) => (next: any) =>
    dealRefreshDeferMiddleware(store)(salesCheckinMiddleware(store)(next) as any);

export const salesCheckinConfiguration = {
    name: APP_NAME,
    defaultRoute: SALESCHECKIN_ROOT_ROUTE,
    middleware: salesCheckinActivityMiddleware,
    reducers: reducer
};
